// extracted by mini-css-extract-plugin
export default {"App":"NotFound_App__ld3eT","error":"NotFound_error__Chhmt"};